// Functions
import VerifyToken from "../../config/verifyToken";
import useReportAccess from "../../config/useReportAccess";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import GlobalPatientAdherenceView from "../../components/globalPatientAdherence";

const GlobalPatientAdherence = () => {
  useReportAccess("GLOBAL_ADHERENCE");

  return (
    <>
      {VerifyToken()}
      <Header />
      <Main>
        <StickyLogo />
        <GlobalPatientAdherenceView />
      </Main>
    </>
  );
};

export default GlobalPatientAdherence;
